import { motion } from "framer-motion";

interface SwatchRowProps {
  /** CSS colour, e.g. "#d4af37". Use `hexOf` for a catalog preset's numeric colour. */
  hex: string;
  label: string;
  selected: boolean;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

/**
 * Horizontal colour-swatch option (round chip + label). `OptionCard` is
 * flex-col only, which is why the engagement Metal section hand-rolled this.
 */
export function SwatchRow({ hex, label, selected, onClick, disabled, className = "" }: SwatchRowProps) {
  return (
    <motion.button
      type="button"
      title={label}
      onClick={onClick}
      disabled={disabled}
      whileHover={disabled ? undefined : { y: -1 }}
      whileTap={disabled ? undefined : { scale: 0.97 }}
      className={`flex items-center gap-2.5 rounded-xl border px-3 py-2.5 transition-colors disabled:opacity-50 ${
        selected
          ? "border-primary bg-surface-container-high/40"
          : "border-outline-variant/40 bg-surface-container-lowest hover:border-outline"
      } ${className}`}
    >
      <span
        className="h-6 w-6 shrink-0 rounded-full"
        style={{ background: hex, boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.15)" }}
      />
      <span className="font-body text-[11px] text-on-surface">{label}</span>
    </motion.button>
  );
}

/** Catalog metal colours are numeric (0xd4af37); swatches want CSS. */
export function hexOf(color: number): string {
  return `#${color.toString(16).padStart(6, "0")}`;
}
